import FormMixinInput from '../components_mixins/FormMixinInput';

export const FormMixin = {
    data() {
        return {
            errors: {},
            model: {},
        };
    },
    provide() {
        return { formData: this };
    },
    components: { FormMixinInput },
    mounted() {
        this.$onInstance('refresh', this.init);
        this.init();
    },
    methods: {
        init() {
            throw 'Method init not implemented';
        },
        resetErrors: function() {
            this.errors = {};
        },
        showError: function(error, container) {
            if (error.status !== 422) {
                this.$toast({
                    message: this.$dicc.errors[error.data.error] || error.data.error,
                    container: container,
                    type: 'is-danger',
                });
                return;
            }

            for (let attribute of Object.keys(error.data.error)) {
                this.$set(
                    this.errors,
                    attribute,
                    error.data.error[attribute].map((code) => this.$dicc.errors[code] || code).join('\r\n')
                );
            }
        },
    },
};
